import React from 'react'
import FaAngleRight from 'react-icons/lib/fa/angle-right'
import { connectStateResults } from 'react-instantsearch/connectors'
import styled from 'styled-components'
import { FilterIcon, FilterTitle, RefinementBadge, SearchResultText } from '../FilterHeader'

const ModalTriggerContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 20px;
  cursor: pointer;
`

const Title = styled.div`
  display: flex;
  align-items: center;
`

const Results = styled.div`
  display: flex;
  align-items: center;
`

const _ModalTrigger = ({ searchState, searchResults, toggle, className }) => (
  <ModalTriggerContainer onClick={toggle}>
    <Title>
      <FilterIcon />
      <FilterTitle>Filter</FilterTitle>
      <RefinementBadge searchState={searchState} />
    </Title>

    <Results>
      <SearchResultText searchResults={searchResults} />
      <FaAngleRight size={18} />
    </Results>

  </ModalTriggerContainer>
)

export const ModalTrigger = connectStateResults(_ModalTrigger)

export const SideBar = styled.div`
  background-color: white;
  display: ${props => (props.isOpen ? 'block' : 'none')};
  z-index: 1050; /* same z-index as Bootstrap Modal */
  position: fixed;
  top: 0;
  right: 0;
  width: 270px;
  height: 100%;
  overflow: auto;
`
